export default "__VITE_ASSET__5ba38cc1__"